<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <h3>携帯キャリアエリアマップ統合版</h3>
        </v-row>
        <v-row>
          <div
            id="mapMobileArea"
            class="map"
            style="height: 70vh; width: 100%; z-index: 1 !important"
          ></div>
        </v-row>
        <!-- <v-row>
          <h4>凡例</h4>
        </v-row>
        <MobileAreaHanrei></MobileAreaHanrei> -->
        <v-row>
          <h4>説明</h4>
        </v-row>
        <v-row dense>
          <v-col> 携帯キャリアのエリアマップを重ねて表示できます。</v-col>
        </v-row>
        <v-row dense>
          <v-col
            >エリアマップは各キャリアからデータを取得していますが、キャッシュが入るため、最新ではないことがあります。</v-col
          >
        </v-row>
        <v-row dense>
          <v-col>マップの凡例は各キャリアのサイトをご確認ください。</v-col>
        </v-row>
        <v-row>
          <h4>Link</h4>
        </v-row>
        <MobileAreaLink></MobileAreaLink>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
// import MobileAreaHanrei from "@/components/MobileAreaHanrei.vue";
import MobileAreaLink from "@/components/MobileAreaLink.vue";

import $ from "jquery";
import L from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
import "leaflet/dist/leaflet.css";

import "leaflet.locatecontrol";
import "leaflet.locatecontrol/dist/L.Control.Locate.css";
import "leaflet.fullscreen";
import "leaflet.fullscreen/Control.FullScreen.css";

import "font-awesome/css/font-awesome.css";

export default {
  components: {
    // MobileAreaHanrei,
    MobileAreaLink,
  },
  data() {
    return {
      isMapActive: true,
      carrierMapList: {},
      map: null,
      layer: null,
      marker: null,
    };
  },
  watch: {},
  mounted() {
    let baseLayers = {};
    baseLayers["国土地理院(白黒)"] = L.tileLayer(
      "https://cyberjapandata.gsi.go.jp/xyz/blank/{z}/{x}/{y}.png",
      {
        attribution:
          'Map <a href="https://maps.gsi.go.jp/development/ichiran.html">国土地理院</a>',
        maxNativeZoom: 14,
        name: "国土地理院(白黒)",
        maxZoom: 19,
        xB: 1,
      }
    );
    baseLayers["OpenStreetMap"] = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        name: "OpenStreetMap",
        maxZoom: 19,
        xB: 2,
      }
    );
    baseLayers["GoogleMap"] = L.tileLayer(
      "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&gl=jp&hl=ja",
      {
        attribution:
          'Map &copy; <a href="https://www.google.co.jp/maps/?hl=ja">Google</a>',
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
        name: "GoogleMap",
        maxZoom: 19,
        xB: 3,
      }
    );
    baseLayers["GoogleMap(Satellite)"] = L.tileLayer(
      "https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}&gl=jp&hl=ja",
      {
        attribution:
          'Map &copy; <a href="https://www.google.co.jp/maps/?hl=ja">Google</a>',
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
        name: "GoogleMap(Satellite)",
        maxZoom: 19,
        xB: 4,
      }
    );
    baseLayers["GoogleMap(GrayScale)"] = L.tileLayer(
      "https://mt.k-tai.biz/map_tile/gmt?x={x}&y={y}&z={z}",
      {
        attribution:
          'Map &copy; <a href="https://www.google.co.jp/maps/?hl=ja">Google</a>',
        name: "GoogleMap(GrayScale)",
        maxZoom: 19,
        xB: 5,
      }
    );

    const defaultMap = "GoogleMap";
    this.map = L.map("mapMobileArea", {
      center: [35.6812362, 139.7649361],
      maxBounds: L.latLngBounds(L.latLng(20.0, 110.0), L.latLng(50.0, 170.0)),
      zoom: 9,
      zoomControl: false,
      minZoom: 6,
      maxZoom: 19,
      layers: [baseLayers[defaultMap]],
    });

    this.layer = L.control
      .layers(null, null, { collapsed: true, hideSingleBase: true })
      .addTo(this.map);
    for (let baseLayer in baseLayers) {
      this.layer.addBaseLayer(
        baseLayers[baseLayer],
        baseLayers[baseLayer].options.name
      );
    }

    L.control.scale({ imperial: false }).addTo(this.map);
    L.control.zoom({ position: "bottomright" }).addTo(this.map);
    L.control
      .locate({
        position: "bottomright",
        cacheLocation: false,
        keepCurrentZoomLevel: true,
        setView: "always",
        initialZoomLevel: 13,
        locateOptions: { enableHighAccuracy: true },
      })
      .addTo(this.map);
    L.control
      .fullscreen({ position: "bottomright", forceSeparateButton: true })
      .addTo(this.map);

    this.marker = L.marker();

    // load carrier map
    this.getCarrierMapList().then(() => {
      for (let key in this.carrierMapList) {
        let options = this.carrierMapList[key].options;
        const tileLayer = L.tileLayer(this.carrierMapList[key].url, options);
        this.layer.addOverlay(tileLayer, this.carrierMapList[key].options.name);
      }
      this.restoreState();
      this.addEvent();
    });
  },
  methods: {
    RoundLatLon(l) {
      return Math.round(l * 1e6) / 1e6;
    },
    getUrlVars() {
      // https://qiita.com/Evolutor_web/items/c9b940f752883676b35d
      var vars = {};
      var param = location.search.substring(1).split("&");
      for (var i = 0; i < param.length; i++) {
        var keySearch = param[i].search(/=/);
        var key = "";
        if (keySearch != -1) key = param[i].slice(0, keySearch);
        var val = param[i].slice(param[i].indexOf("=", 0) + 1);
        if (key != "") vars[key] = decodeURI(val);
      }
      return vars;
    },
    updateShareUrl() {
      const vueObj = this;
      const _getLayer = function () {
        let bitB = 0;
        let bitC = 0;
        let selectedBaseName = $(
          ".leaflet-control-layers-list input:radio:checked"
        )
          .siblings("span")
          .text()
          .trim();
        let selectedCarrierNames = [];
        $(".leaflet-control-layers-list input:checkbox:checked")
          .siblings("span")
          .each(function (i, carrier) {
            selectedCarrierNames.push($(carrier).text().trim());
          });

        for (let l in vueObj.layer._layers) {
          const name = vueObj.layer._layers[l].layer.options.name;
          if (
            vueObj.layer._layers[l].layer.options.xB !== undefined &&
            name === selectedBaseName
          ) {
            bitB = vueObj.layer._layers[l].layer.options.xB;
          }
          if (
            vueObj.layer._layers[l].layer.options.xC !== undefined &&
            selectedCarrierNames.indexOf(name) !== -1
          ) {
            bitC += vueObj.layer._layers[l].layer.options.xC;
          }
        }

        return [bitB, bitC];
      };
      const _isViewMarker = function () {
        return Number(vueObj.marker.isPopupOpen());
      };

      if (!this.isMapActive) {
        return;
      }
      const center = this.map.getCenter();
      const lat = this.RoundLatLon(center.lat);
      const lon = this.RoundLatLon(center.lng);
      const zoom = this.map.getZoom();
      const layer = _getLayer();
      const q =
        "?lat=" +
        lat +
        "&lon=" +
        lon +
        "&z=" +
        zoom +
        "&b=" +
        layer[0] +
        "&c=" +
        layer[1] +
        "&cm=" +
        _isViewMarker();
      history.replaceState("", "", q);
    },
    viewMarker(lat, lon) {
      lat = this.RoundLatLon(lat);
      lon = this.RoundLatLon(lon);
      const msg = "緯度:" + lat + "<br>\n経度:" + lon;
      this.marker
        .setLatLng(L.latLng(lat, lon))
        .bindPopup(msg, {
          closeButton: false,
          closeOnEscapeKey: false,
          closeOnClick: false,
        })
        .addTo(this.map)
        .openPopup();
    },
    getCarrierMapList() {
      return axios
        .get("https://dev.k-tai.biz/data/mobile_area/map_url.json")
        .then((response) => {
          if (Object.keys(response.data).length === 0) {
            throw new TypeError();
          }
          this.carrierMapList = response.data;
        })
        .catch((e) => {
          console.log(e);
          alert(
            "ただいま利用できません。\n---\n初期データの読み込みに失敗しました。"
          );
        });
    },
    addEvent() {
      const vueObj = this;
      /* add event */
      this.map.on(
        "moveend zoomend baselayerchange overlayadd overlayremove layeradd layerremove",
        function () {
          vueObj.updateShareUrl();
        }
      );
      this.map.on("contextmenu", function (e) {
        vueObj.viewMarker(e.latlng.lat, e.latlng.lng);
      });

      this.marker.on("click", function () {
        vueObj.marker.remove();
      });
    },
    restoreState() {
      /* latitude & longitude */
      const p = this.getUrlVars();
      if (
        p["lat"] !== undefined &&
        p["lon"] !== undefined &&
        p["z"] !== undefined
      ) {
        const lat = p["lat"];
        const lon = p["lon"];
        const z = p["z"];
        if (
          lat >= 20.0 &&
          lat <= 50.0 &&
          lon >= 110.0 &&
          lon <= 170.0 &&
          z >= 6 &&
          z <= 19
        ) {
          this.map.setView(L.latLng(lat, lon), z, { animate: false });
        }
      }

      /* map layer */
      if (p["b"] !== undefined) {
        const b = p["b"];
        let targetBaseName = "";
        for (let l in this.layer._layers) {
          if (this.layer._layers[l].layer.options.xB === undefined) {
            continue;
          }
          if (b == this.layer._layers[l].layer.options.xB) {
            targetBaseName = this.layer._layers[l].layer.options.name;
            break;
          }
        }

        $(".leaflet-control-layers-list .leaflet-control-layers-base div").each(
          function (i, layer) {
            const baseName = $(layer).children("span").text().trim();
            if (targetBaseName === baseName) {
              $(layer).children("input").click();
            }
          }
        );
      }

      if (p["c"] !== undefined) {
        const c = p["c"];
        let targetCarrierNames = [];
        for (let l in this.layer._layers) {
          if (this.layer._layers[l].layer.options.xC === undefined) {
            continue;
          }
          if (
            (c & this.layer._layers[l].layer.options.xC) ===
            this.layer._layers[l].layer.options.xC
          ) {
            targetCarrierNames.push(this.layer._layers[l].layer.options.name);
          }
        }

        $(
          ".leaflet-control-layers-list .leaflet-control-layers-overlays div"
        ).each(function (i, layer) {
          const carrierName = $(layer).children("span").text().trim();
          if (targetCarrierNames.indexOf(carrierName) !== -1) {
            $(layer).children("input").click();
          }
        });
      }
    },
  },
  beforeDestroy() {
    this.isMapActive = false;
  },
};
</script>
<style>
div.leaflet-top.leaflet-right {
  z-index: 1200;
}
</style>